
<div class="visual-editor-top justify-content-between mx-5">
  <div class="visual-editor-type-dropdown">
    <span class="user-select-none">
      <span class="c-red p-relative not-1">*</span>
      <strong>Type:</strong>
    </span>
    <mat-select class="ml-10 trg-outline h-30 fs-12 visual-editor-dropdown user-select-none"
                panelClass="trg-outline-dropdown visual-editor-dropdown-panel visual-editor-dropdown-panel-canvas"
                [disabled]="busy()"
                placeholder="Select Type"
                [ngModel]="visualEditor.visualPbiChartType()"
                (ngModelChange)="visualEditor.setChartType($event)">
      <mat-select-trigger>
        @let selectedChartType = visualEditor.visualPbiChartType();
        @if (selectedChartType) {
          <ng-container *ngTemplateOutlet="
                        chartOption;
                        context: { chartType: selectedChartType }"></ng-container>
        }
      </mat-select-trigger>
      @for (ct of chartTypes; track ct) {
        <mat-option [value]="ct">
          <ng-container *ngTemplateOutlet="
                        chartOption;
                        context: { chartType: ct }"></ng-container>
        </mat-option>
      }
    </mat-select>
    <ng-template #chartOption let-chartType="chartType">
      <div class="d-flex align-items-center w-100p" [title]="chartType.title">
        @if (chartType.previewImageUrl) {
          <img [src]="chartType.previewImageUrl"
               [alt]="chartType.title"
               class="size-18 mr-8" />
          <span>{{chartType.title}}</span>
        }
      </div>
    </ng-template>
  </div>

  @if (allowLocaleSelection()) {
  <div class="visual-editor-locale-dropdown ml-20">
    <span class="user-select-none">
      <span class="c-red p-relative not-1">*</span>
      <strong>Locale:</strong>
    </span>

    @let sl = visualEditor.effectiveLocale();

    <mat-select class="ml-10 trg-outline h-30 fs-12 visual-editor-dropdown user-select-none"
                panelClass="trg-outline-dropdown visual-editor-dropdown-panel visual-editor-dropdown-panel-canvas"
                placeholder="Select Currency"
                [ngModel]="visualEditor.effectiveLocale()?.id"
                (ngModelChange)="setSelectedLocale($event)">
      <mat-select-trigger>
        @if (sl) {
          <span>{{sl.name}}</span>
        }
      </mat-select-trigger>

      @for (l of locales(); track l.id) {
      <mat-option [value]="l.id">
        <div>
          <div class="locale-name">{{l.name}} ({{l.id}})</div>
          <div class="locale-item">
            <div>Date:</div>
            <div>{{l.formats.timestamp.date}}</div>
            <div>Time:</div>
            <div>{{l.formats.timestamp.time}}</div>
            <div>Number:</div>
            <div>{{l.numberFormatExample}}</div>
          </div>
        </div>
      </mat-option>
      }
    </mat-select>

    @if (sl) {
      <div>
        <div class="locale-item">
          <div>Date:</div>
          <div>{{sl.formats.timestamp.date}}</div>
          <div>Time:</div>
          <div>{{sl.formats.timestamp.time}}</div>
          <div>Number:</div>
          <div>{{sl.numberFormatExample}}</div>
        </div>
      </div>
    }
  </div>
  }

  <div class="visual-editor-currency-dropdown ml-20" [hidden]="!currencySelection()">
    <span class="user-select-none">
      <span class="c-red p-relative not-1">*</span>
      <strong>Currency:</strong>
    </span>

    @if (currenciesLoading()) {
      <loading-rect size="100% 30px"></loading-rect>
    }
    @else {
      <mat-select class="ml-10 trg-outline h-30 fs-12 visual-editor-dropdown user-select-none"
                  panelClass="trg-outline-dropdown visual-editor-dropdown-panel visual-editor-dropdown-panel-canvas"
                  placeholder="Select Currency"
                  [formControl]="visualEditor.visualCurrency.control">
        @for (c of currencies().currencies; track c) {
        <mat-option [value]="c">
          <span>{{c.displayName}}</span>
        </mat-option>
        }
      </mat-select>
    }
  </div>
</div>

<div class="visual-editor-canvas-section-wrapper">
  <div class="visual-editor-canvas-section-top">
    <div class="d-flex fs-12 filters-header">
      <button trgButton color="white"
              class="w-20 h-26 px-0 mr-8"
              [disabled]="busy()"
              (click)="setFiltersCollapsed(!filtersCollapsed())">
        <i class="fas fa-chevron-double-left i-12 p-relative ot-1 filters-collapse-icon"></i>
      </button>
      <div class="d-flex align-items-center justify-content-between filters-header-inner"
           [hidden]="filtersCollapsed() && dropping()">
        <div class="d-flex align-items-center filters-btn">
          <i class="fas fa-filter i-12 mr-6"></i>
          <span>Filters ({{filters().length}})</span>
        </div>
        <div class="d-flex align-items-center filters-btn filters-collapsed-hide filters-clear-all-btn" (click)="filtersChange([])">
          <span>Clear All</span>
          <i class="fas fa-trash-alt ml-6"></i>
        </div>
      </div>
      <div class="filters-header-drop"
           [hidden]="!filtersCollapsed() || !dropping()"
           trgDrop
           [dropExpand]="[10, 10]"
           (trgDropEnter)="onFilterDropEnter($event)"
           (trgDropExit)="onFilterDropExit($event)"
           (trgDropped)="onFilterDropped($event)">
        <i class="fas fa-filter i-10 mr-6 ot-2 p-relative"></i>
        <span>Drop Filter Here</span>
      </div>
    </div>

    <div class="visual-header">
      <div class="visual-header-inner">
        <div class="visual-header-inner-left">
          @if (showRowCount()) {
            @let rc = rowCount();
            <span class="visual-row-count" [hidden]="!rowCountAvailable() || rc.error">
              <span class="visual-row-count__label mr-4">Total Rows:</span>
              @if (rc.loaded) {
                <span class="visual-row-count__value">{{rc.rowCount}}</span>
              }
              @else {
                <loading-rect size="35px 10px"></loading-rect>
              }
            </span>
          }
        </div>
        <div class="visual-header-inner-right">
          <div class="refresh-needed-warning" [hidden]="!refreshPending()">
            <i class="fas fa-exclamation-triangle c-orange mr-4 i-14"></i>
            <span>Report definition has been modified</span>
          </div>
          @if (canViewQueryPlan()) {
            <div>
              <span class="mr-4">Query Plan:</span>
              @if (queryId()) {
                @if (queryPlanLoaded()) {
                  <a class="underline c-blue pointer" (click)="viewQueryPlanClick()">
                    View
                  </a>
                }
                @else if (queryPlanLoading()) {
                  <span>Loading...</span>
                }
                @else {
                  <a class="underline c-blue pointer" (click)="loadQueryPlanClick()">
                    Load
                  </a>
                }
              }
              @else {
                <span>-</span>
              }
            </div>
          }
        </div>
      </div>
      <button trgButton color="primary" class="h-26 lh-26 ml-10 fs-12"
              [hidden]="!refreshPending()"
              (click)="refreshVisual.emit()">
        <i class="far fa-sync i-10 mr-4"></i>
        <span>Refresh Visual</span>
      </button>
    </div>
  </div>

  <div class="visual-editor-canvas-section-bottom">
    <div class="visual-editor-canvas-section-filters">
      <filter-editor-list [groups]="filterEditorGroups()"
                          
                          [filters]="filters()"
                          (filtersChange)="filtersChange($event)"></filter-editor-list>
    </div>

    <div class="visual-editor-canvas-section-visual">
      @if (userDatasetFailure()) {
        <div class="d-flex h-100p fs-26 c-grey-6 justify-content-center align-items-center">
          <p>
            The extended dataset has failed to load.
            <br />
            You may attempt to refresh it.
          </p>
        </div>
      }
      @else if (!readyToRender()) {
        <visual-placeholder [visualType]="visualEditor.visualPbiChartType()"></visual-placeholder>
      }
      @else {
        @if (!visualEditor.reloadVisualHost()) {
          <pbir-visual-host [busy]="busy()"
                            [visual]="visual()"
                            [dataSource]="visualDataSource()"
                            (stateChanged)="onVisualHostStateChange()"
                            (beforeVisualEvent)="onBeforeVisualEvent($event)"
                            #visualHost>
          </pbir-visual-host>
        }

        @if (needsHostLoadingOverlay()) {
          <div class="visual-editor-canvas__host-loading-overlay"
               [class.visual-editor-canvas__host-loading-overlay-visible]="!visualRendered() && readyToRender()">
            <app-spinner></app-spinner>
          </div>
        }
      }
    </div>
  </div>
</div>

<ng-template #planTemplate>
  @if (queryPlan()) {
    <query-plan-view [plan]="queryPlan()"></query-plan-view>
  }
</ng-template>
